var _rect, _g, _circle, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStep3Active(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 42,
    height: 42,
    rx: 21,
    fill: "#1A427D"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_687_4795)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.7757 27.0692H14.3378C14.0263 27.0692 13.7737 27.3218 13.7737 27.6333C13.7737 27.9448 14.0263 28.1974 14.3378 28.1974C15.2155 28.1974 15.9296 28.9093 15.9296 29.7843C15.9296 30.6593 15.2155 31.3712 14.3378 31.3712H14.2313C13.35 31.3712 12.633 30.6543 12.633 29.773V11.6282H27.1419V22.9326C27.1419 23.2441 27.3945 23.4967 27.706 23.4967C28.0175 23.4967 28.2701 23.2441 28.2701 22.9326V11.0641C28.2701 10.7526 28.0175 10.5 27.706 10.5H12.069C11.7575 10.5 11.5049 10.7526 11.5049 11.0641V29.773C11.5049 31.3158 12.8146 32.5313 14.3378 32.4994H27.7758C29.2756 32.4994 30.4959 31.2814 30.4959 29.7843C30.4959 28.2872 29.2756 27.0692 27.7757 27.0692ZM27.7757 31.3712H16.5436C17.2216 30.4348 17.2216 29.1339 16.5436 28.1974H27.7757C28.6535 28.1974 29.3676 28.9093 29.3676 29.7843C29.3676 30.6593 28.6535 31.3712 27.7757 31.3712Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2724 15.5108C19.7286 15.2863 19.6368 15.1813 19.6368 15.031C19.6368 14.8569 19.7849 14.757 20.0431 14.757C20.4031 14.757 20.7215 14.9355 21.0234 15.1114L21.3953 14.1316C21.1106 13.955 20.8066 13.8135 20.4723 13.7617V13.0996H19.4822V13.8231C18.8668 14.0117 18.4887 14.4974 18.4887 15.1098C18.4887 15.9107 19.13 16.2696 19.756 16.5146C20.2497 16.7143 20.3177 16.8787 20.3177 17.0265C20.3177 17.2409 20.1247 17.3793 19.8259 17.3793C19.4118 17.3793 19.0563 17.1699 18.7313 16.9362L18.373 17.934C18.6784 18.1789 19.0486 18.3308 19.4361 18.3841V19.0695H20.4329V18.3258C21.0675 18.1293 21.4724 17.6102 21.4724 16.9806C21.4724 16.3018 21.1023 15.8485 20.2724 15.5108Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8543 21.6565H14.9215C14.61 21.6565 14.3574 21.404 14.3574 21.0924C14.3574 20.7808 14.61 20.5283 14.9215 20.5283H24.8542C25.1658 20.5283 25.4183 20.7808 25.4183 21.0924C25.4183 21.404 25.1658 21.6565 24.8543 21.6565Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9438 24.8491H14.9215C14.61 24.8491 14.3574 24.5966 14.3574 24.285C14.3574 23.9735 14.61 23.7209 14.9215 23.7209H22.9438C23.2553 23.7209 23.5079 23.9735 23.5079 24.285C23.5079 24.5966 23.2553 24.8491 22.9438 24.8491Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.706 25.8907C28.0694 25.8907 28.3641 25.596 28.3641 25.2326C28.3641 24.8691 28.0694 24.5745 27.706 24.5745C27.3425 24.5745 27.0479 24.8691 27.0479 25.2326C27.0479 25.596 27.3425 25.8907 27.706 25.8907Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21.5,
    r: 18.5,
    stroke: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_687_4795"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(10 10.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStep3Active);
export default __webpack_public_path__ + "static/media/step3-active.0b38b8aeccbbbf452df8cc591f872ccb.svg";
export { ForwardRef as ReactComponent };